import React, { Component } from 'react'
import { Row, Col, Card, CardBody, Alert, Button, } from 'reactstrap'
import {
  ItemQuestion, ItemAnswer,
  ItemFeedback, ItemPassage,
  ItemBasicNavMath, ItemTimerCard, ItemCircles, AssessSubmitModal, AssessDirectionsModal,
} from '../AssessTest'
import {
  ItemAnswers, CurrentQuestionAlert
} from './AssessTestComponents'
import values from 'mout/object/values'
import keys from 'mout/object/keys'
import queryString from 'query-string'
import { Link } from 'react-router-dom'
import uuid from 'uuid/v1'
import { forceCheck } from 'react-lazyload';
import arrayifyWithKey from '../../../helpers/arrayifyWithKey'
import alphaNum from '../../../helpers/alphaNum'
import alphaNumF from '../../../helpers/alphaNumF'
import getCorrectAnswer from '../../../helpers/assessment/getCorrectAnswer'
import totalArray from '../../../helpers/totalArray'
import { connect } from 'react-redux';
import Slider from "react-slick";
import ReactModal from 'react-modal';
import createMarkup from '../../../helpers/createMarkup'
import { BeatLoader } from 'react-spinners';

/* AssessTestTake:

  <AssessTestItemView
    activeItem={props.activeItem}
    selectAnswer={props.selectAnswer}
    selectedAnswer={props.selectedAnswer}
    itemNumber={props.itemNumber}
    nextItemLinkTo={`?item=${parseInt(props.itemNumber) + 1}`}
    completed={completed}
    handleSubmit={props.handleSubmitActivity}
    lastItemNumber={lastItemNumber}
    handleQuickNav={props.handleQuickNav}
    timeRemaining={props.timeRemaining}
    isGroup={props.isGroup}
    assessmentId={props.assessmentId}
    selectedStudent={props.selectedStudent}
    answersByItem={answersByItem}
  />

*/

// Question, Answer Choices (each of which can be selected), submit answer button, feedback, lock out if already completed
// itemQuestion props: active, choice, answer

/*

When completed:
  Display the work and the feedback
  Link to next item

At all times:
  Arrows left and right to navigate to next and previous items
  Nav back to Assignments


  IF NEXTITEMLINKTO === '' THEN WE HAVE TO GO BACK TO THE ASSIGNMENT PAGE AS THE LINK...
*/
ReactModal.setAppElement('#root');
class AssessTestItemViewMath extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showModal: false
    }
    this.handleChangeItem = this.handleChangeItem.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.toggleModal = this.toggleModal.bind(this);

  }

  componentWillMount() {

    setTimeout(() => {
    }, 500);

  }

  componentDidMount() {
    window.addEventListener('keypress', this.handleKeyPress, false)
    window.addEventListener('keydown', this.handleKeyDown, false)
    forceCheck();
    

  }

  handleKeyDown(e) {
    const { keyCode } = e
    const { itemNumber, lastItemNumber } = this.props
    switch (keyCode) {
      case 33:
      case 37:
        e.preventDefault()
        if (
          itemNumber &&
          Number(itemNumber) >= 2
        ) {
          this.handleChangeItem(Number(itemNumber) - 1, 'prev')
        }
        break
      case 34:
      case 39:
        e.preventDefault()
        if (
          itemNumber &&
          itemNumber != lastItemNumber
        ) {
          this.handleChangeItem(Number(itemNumber) + 1, 'next')
        }
        break
    }
  }

  handleKeyPress({ key }) {
    const { activeItem, selectAnswer, selectedAnswer, completed } = this.props
    const keypress = {
      a: 'answer0000',
      b: 'answer0001',
      c: 'answer0002',
      d: 'answer0003',
      e: 'answer0004',
      f: 'answer0000',
      g: 'answer0001',
      h: 'answer0002',
      j: 'answer0003',
      k: 'answer0004',
    }
    if (key && keypress[key] && !completed) {
      const selected = selectedAnswer === keypress[key]
      if (activeItem && activeItem.answers) {
        if (key === 'e' || key === 'k') {
          if (keys(activeItem.answers).length < 5) return
        }
        selectAnswer(selected ? '' : keypress[key])
      }
    }
  }


  componentWillReceiveProps(nextProps) {
    this.props.itemNumber !== nextProps.itemNumber && nextProps.activeItem && this.slider && this.slider.slickGoTo(Number(nextProps.itemNumber) - 1, false);
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions, false)
    window.removeEventListener('keypress', this.handleKeyPress, false)
    window.removeEventListener('keydown', this.handleKeyDown, false)
  }


  toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }


  handleChangeItem(nextItem, nextOrPrev) {
    const { search, navTo } = this.props
    const { assessmentId, selectedGroupUA, selectedStudent } = this.props
    const g = selectedGroupUA ? 'g=true&' : ''
    const a = selectedGroupUA || selectedStudent ? `a=${assessmentId}&` : ''
    this.props.navTo(`?${a}${g}item=${Number(nextItem)}`);

    if (nextOrPrev === 'prev') {
      this.slider.slickPrev();
    }

    else if (nextOrPrev === 'next') {
      this.slider.slickNext();
    }

    else if (nextOrPrev === 'submit') {
      const qs = queryString.parse(search)
      qs.m = 'submit'
      const newQuery = queryString.stringify(qs)
      return navTo(`?${newQuery}`)
    }

  }

  render() {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    var isEdge = navigator.appVersion.indexOf('Edge') > -1
    const props = this.props
    let subtestName = '', testName = ''
    if (props.userAssessment) {
      subtestName = props.userAssessment.assessmentSubtests[props.subtestId].displayName
      testName = props.userAssessment.assessmentSet.displayName
    }


    let correctAnswer = ''
    if (/*props.completed && */!props.selectedAnswer && props.activeItem) {
      correctAnswer = getCorrectAnswer(props.activeItem.answers)
    }




    let itemPassage = null
    let itemViewCols = {
      xs: '12',
      md: '12'
    }
    if (props.activeItem) {
      if (props.activeItem.passageId || props.activeItem.passage) {
        let sectionBreaks = []
        if (props.userAssessment && props.userAssessment.assessmentSubtests[props.subtestId]) {
          sectionBreaks = props.userAssessment.assessmentSubtests[props.subtestId].sectionBreaks
        }
        let uAid = ''
        if (props.isGroup && !props.selectedStudent) {
          uAid = props.selectedGroupUA
        } else {
          props.userAssessment ? uAid = props.userAssessment.userAssessmentId : null
        }
        itemPassage = (
          <Col xs='12' md='7'>
            <ItemPassage
              passage={props.activeItem ? props.activeItem.passage : ''}
              sectionBreaks={sectionBreaks}
              subtestId={props.subtestId}
              uAid={uAid}
              itemNumber={props.itemNumber}
              assessmentId={props.assessmentId}
              isGroup={props.isGroup}
            />
          </Col>
        )
        itemViewCols.md = '12'
      }
    }

    let alert = null
    if (props.user) {
      if (
        (!props.answersByItem && props.user.role !== 'Student') ||
        (props.selectedStudent && !props.selectedAnswer)
      ) {
        let text = 'This student has not answered this item.'
        if (props.isGroup && !props.selectedStudent) {
          text = 'No selected students have answered this item.'
          if (!props.activeItem) {
            text = 'No selected students have completed this test.'
          }
        }
        alert = (
          <Alert color='warning'>
            {text}
          </Alert>
        )
      }
    }

    const qs = props.search ? queryString.parse(props.search) : {}
    function getSubmitQueryString(qs) {
      let queryObj = Object.assign({}, qs)
      queryObj.m = 'submit'
      return queryString.stringify(queryObj)
    }



    function timerDanger() {
      if (props.activeItem && props.timeRemaining < 300000 && props.timeRemaining >= 60000) {
        return ' warning';
      } else if (props.activeItem && props.timeRemaining < 60000) {
        return ' danger';
      } else {
        return ''
      }
    }


    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        color: "#62b6e8",
        backgroundColor: "rgb(216, 216, 216)"
      }
    };
    const spanStyle = {
      color: "#6e6e6e",
      float: "right",
      cursor: "pointer"
    };
    const divPaddingStyle = {
      paddingTop: "14px"
    };


    const submitQueryString = getSubmitQueryString(qs)

    let directions = ''
    if (props.userAssessment && props.userAssessment.assessmentSubtests[props.subtestId]) {
      directions = props.userAssessment.assessmentSubtests[props.subtestId].directions
    }

    const directionsQS = {
      ...qs,
      m: 'directions',
    }
    const directionsLink = queryString.stringify(directionsQS)

    const overviewQS = {
      ...qs,
      item: 'overview'
    }
    const overviewLink = queryString.stringify(overviewQS)

    const {
      completed,
      assessmentId,
      answersByItemAll,
      items,
      itemNumber,
      userAssessment,
      selectAnswer,
      answersByItem,
      isGroup,
      selectedAnswer,
      user,
      selectedStudent,
      subtestId } = this.props

    const itemsAll = userAssessment && userAssessment.destructuredSubtests && userAssessment.destructuredSubtests[subtestId].items;
    const settings = {
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 1,
      touchMove: false,
      className: "center variable-width",
      adaptiveHeight: true,
      centerMode: true,
      speed: 200,
      arrows: false,
      vertical: false,
      variableWidth: true,
      initialSlide: itemNumber === 1 ? itemNumber : Number(itemNumber) - 1,
      lazyLoad: isEdge,
      afterChange: () => {
        forceCheck();
      },


    };
    return (
      itemsAll ? <Row className={completed ? 'test-complete' : ''}>
        {/* Jeff, use this to get measurements for cleaning up transitions */}
        {/* <div style={{
          position: 'fixed',
          color: 'red',
          background: 'white',
          zIndex: '200'
        }}>
          <p>questionPrevPrevWidth: {`${this.state.questionPrevPrevWidth}`}</p>
          <p>questionPrevWidth: {`${this.state.questionPrevWidth}`}</p>
          <p>questionCirremtWidth: {`${this.state.questionCurrentWidth}`}</p>
        </div> */}
        
        <AssessSubmitModal
          handleSubmitSubtest={props.handleSubmitSubtest}
          isOpen={qs.m === 'submit'}
          navTo={props.navTo}
          search={props.search}
          user={props.user}
                activeItem={props.activeItem}
                answersByItem={userAssessment && userAssessment.answersByItem}
                userAssessment={props.userAssessment}
                groupUA={props.groupUA}
                selectedStudent={props.selectedStudent}
                subtestId={props.subtestId}
                itemNumber={props.itemNumber}
                completed={props.completed}
                isGroup={props.isGroup}
                selectedGroupUA={props.selectedGroupUA}
                items={props.items}
                assessmentId={assessmentId}
        />
        <AssessDirectionsModal
          isOpen={qs.m === 'directions'}
          directions={directions}
          navTo={props.navTo}
          search={props.search}
        />
        <Col xs='12' xl='12'>
          <Card className='assessment-test-item-view'>
            <Row className='assessment-test-header rounded-top' noGutters>
              <Col className='test-title-container' xs='12' sm='6'>
                <h4 className='test-title'>{`${testName}: ${subtestName}`}</h4>
              </Col>
              <Col className='test-resources' xs='12' sm='6'>
                <div className="view-directions">
                  <p>
                    <Link to={`?${directionsLink}`}>
                      🔎 View Directions
                    </Link>
                  </p>
                </div>
                <div className={`test-timer-container${timerDanger()}`}>
                  {
                    props.activeItem
                      ? <ItemTimerCard
                        timeRemaining={props.timeRemaining}
                        completed={props.completed}
                      />
                      : null
                  }
                </div>
              </Col>
            </Row>

            <Row className='assessment-test-body'>
              {/* {itemPassage} */}

              <Col xs='12' md={itemViewCols.md}>
                <Row className='questions-container active'>
                  <Col className='questions-column math-questions'>


                    {items ? <Slider ref={c => (this.slider = c)}  {...settings}>


                      {itemsAll && itemsAll.map((itemID, val) => {

                        const item = items && items[itemID];
                        const answerSelected = userAssessment && userAssessment.answersByItem && userAssessment.answersByItem[subtestId] && userAssessment.answersByItem[subtestId][itemID];
                        const scoring_list = props.userAssessment && props.userAssessment.scoring && props.userAssessment.scoring.byItem  && props.userAssessment.scoring.byItem[subtestId];
                        return <div key={val} className={`question-wrapper`}>
                          <Card className={`question math`}>
                            <div className='prev-nav-link'>
                              <ItemBasicNavMath
                                itemNumber={Number(val) + 1}
                                lastItemNumber={props.lastItemNumber}
                                isGroup={props.isGroup}
                                assessmentId={props.assessmentId}
                                selectedStudent={props.selectedStudent}
                                prev={true}
                                completed={props.completed}
                                handleChangeItem={this.handleChangeItem}
                              />
                            </div>
                            <CardBody>
                              <div className='question-number'>
                                {item && `Question ${Number(val) + 1} of ${props.lastItemNumber}`}
                              </div>

                              <CurrentQuestionAlert
                                answersByItem={answersByItem}
                                user={user}
                                selectedStudent={selectedStudent}
                                selectedAnswer={selectedAnswer}
                                isGroup={isGroup}
                                activeItem={item}
                              />

                              <ItemQuestion question={item ? item.question : null} />

                              {item &&
                                <ItemAnswers
                                  activeItem={item}
                                  isGroup={isGroup}
                                  answersByItem={answersByItem}
                                  selectedAnswer={answerSelected}
                                  selectAnswer={selectAnswer}
                                  completed={completed}
                                  scoring = {scoring_list}
                                />
                              }

                              {item &&
                                <ItemFeedback
                                  feedback={selectedAnswer ? item.answers && item.answers[selectedAnswer] && item.answers[selectedAnswer].feedback : item.answers && item.answers[correctAnswer] && item.answers[correctAnswer].feedback}
                                  completed={completed}
                                  videoFeedback={item.videoFeedback}
                                  videoFeedbackThumbnail={item.videoFeedbackThumbnail}
                                  toggleModal={this.toggleModal}
                                />
                              }
                            </CardBody>
                            <div className='next-nav-link'>
                              <ItemBasicNavMath
                                itemNumber={Number(val) + 1}
                                lastItemNumber={props.lastItemNumber}
                                isGroup={props.isGroup}
                                assessmentId={props.assessmentId}
                                selectedStudent={props.selectedStudent}
                                next={true}
                                completed={props.completed}
                                handleChangeItem={this.handleChangeItem}
                              />
                            </div>
                          </Card>
                        </div>



                      })
                      }
                    </Slider> :
                      <div style={{ textAlign: 'center', padding: '100px' }}><BeatLoader loading /></div>
                    }




                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    {
                      props.activeItem
                        ? <ItemNavCard
                          lastItemNumber={props.lastItemNumber}
                          thisItemNumber={props.itemNumber}
                          handleQuickNav={props.handleQuickNav}
                          isGroup={props.isGroup}
                          assessmentId={props.assessmentId}
                          selectedStudent={props.selectedStudent}
                        />
                        : null
                    }
                  </Col>
                </Row> */}

              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs='12' xl='12'>
          <Card className='test-overview-nav'>
            <Row className='assessment-test-header rounded-top' noGutters>
              <Col xs='12'>
                &nbsp;
        </Col>
            </Row>
            {props.activeItem &&
              <ItemCircles
                user={props.user}
                activeItem={props.activeItem}
                answersByItem={userAssessment && userAssessment.answersByItem}
                userAssessment={props.userAssessment}
                groupUA={props.groupUA}
                selectedStudent={props.selectedStudent}
                subtestId={props.subtestId}
                itemNumber={props.itemNumber}
                completed={props.completed}
                isGroup={props.isGroup}
                selectedGroupUA={props.selectedGroupUA}
                items={props.items}
                assessmentId={assessmentId}
              />
            }
            {props.activeItem && !props.completed &&
              <Link className='submit-test' to={`?${submitQueryString}`}><Button>Submit Test</Button></Link>
            }
            {props.activeItem && props.completed &&
              <Link className='back-to-overview' to={`?${overviewLink}`}>Back to Overview</Link>
            }
          </Card>
          {props.activeItem && props.activeItem.videoFeedback && <div>
            <ReactModal
              isOpen={this.state.showModal}
              contentLabel="Video Feedback"
              style={customStyles}
              shouldCloseOnEsc={true}
              shouldCloseOnOverlayClick={true}
            >

              <div className="modal-video" dangerouslySetInnerHTML={createMarkup(props.activeItem.videoFeedback)}></div>
              <div style={divPaddingStyle}>
                <span onClick={this.toggleModal} style={spanStyle} >
                  Close
                                </span>
              </div>
            </ReactModal>
          </div>}
        </Col>
      </Row > : alert
    )
  }
}


export default connect(
  (state) => ({
    items: state.assessment.items,
  })
)(AssessTestItemViewMath)





// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessTestItemViewMath.js